import http from "./http";

/**
 * "Xem với tư cách station" — admin mở portal của một station ở chế độ CHỈ ĐỌC.
 *
 * Không liên quan gì tới mật khẩu của station: backend tự ký một vé tạm (JWT ngắn hạn,
 * mang claim `act_as`), station KHÔNG bị đăng xuất và KHÔNG nhận thông báo đổi mật khẩu.
 *
 * Backend đã live từ 2026-08-06 nên chế độ xem thử đã được gỡ: `url` trả về là URL
 * thật, đã kèm vé ở fragment (`#act=`). Cổng trạm bắt vé đó ngay khi trang khởi động
 * rồi xoá khỏi thanh địa chỉ.
 */
export type ImpersonationSession = {
	/** URL đầy đủ để mở portal station (backend trả về, đã kèm vé tạm) */
	url: string;
	/** ISO timestamp — hết hạn thì vé tự chết, phải mở lại từ Admin */
	expiresAt: string;
	/** Tên station đang xem, để hiển thị lại cho admin xác nhận */
	stationName?: string;
};

/**
 * Mở một phiên xem chỉ-đọc cho station.
 *
 * Trả về 201 chứ không phải 200.
 *
 * @param partnerId  Partner.id của station
 * @param reason     Lý do — đi thẳng vào nhật ký audit, nên bắt buộc và nên cụ thể
 */
export async function startStationImpersonation(partnerId: string, reason: string): Promise<ImpersonationSession> {
	const { data } = await http.post("/admin/stations/impersonate", { partnerId, reason });
	return data as ImpersonationSession;
}
